import { IBondGrossReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_DELTA_SHEKEL';

export type IReportGrossDeltaShekelItem = IBondGrossReport & { __isSelected: boolean };
